import { SnackbarContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '@/globalStyles';
var variantColors = {
    success: colors.primary || '#4caf50',
    error: colors.error || '#f44336',
    info: colors.nero || '#2196f3',
    warning: colors.warning || '#ff9800',
    default: colors.primary || '#1976d2',
};
export var SnackbarContentStyled = styled(SnackbarContent, {
    shouldForwardProp: function (prop) { return prop !== 'customVariant'; },
})(function (_a) {
    var customVariant = _a.customVariant;
    return ({
        backgroundColor: variantColors[customVariant || 'default'],
        color: '#fff',
        fontFamily: 'Lato, sans-serif',
        borderRadius: 8,
        boxShadow: '0 3px 5px rgba(0,0,0,0.3)',
        padding: '6px 16px',
        maxWidth: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    });
});
